import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { UserListQueries } from '@/queries/users/queries.ts'
import { usePageHeader } from '@/layouts/PageHeaderProvider.tsx'
import { useEffect } from 'react'
import HistoryView from '../../applicants/applicant_details/HistoryView.tsx'
import { historyType } from '@/app/common/constants'

export default function UsersHistoryView() {
  const { setTitle } = usePageHeader()
  const { userId } = useParams<{ userId?: string }>()
  const userQueryOptions = UserListQueries.getUserById(userId)

  const UserData = useQuery({
    ...userQueryOptions,
    enabled: !!userId,
  })

  useEffect(() => {
    if (UserData.data?.first_name) {
      setTitle(`${UserData.data.first_name} ${UserData.data?.last_name}`)
    }
  }, [UserData.data?.first_name])

  if (UserData.error) {
    return <div>{UserData.error?.message ?? ''}</div>
  } else if (UserData.data?.id) {
    return (
      <HistoryView
        user_id={UserData.data?.id}
        user_type_id={historyType.user}
      />
    )
  } else {
    return <></>
  }
}
